import React, { useRef, useState } from "react";
import { Button, Container, Form, Row, Col } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import "../style.scss";
import * as yup from "yup";
import { useFormik } from "formik";
import PreviewImage from "../../../Component/previewImage";
import { FileBox } from "../../../Component/form";
import { apiAdminConfig } from "../../../utils/api";
import useToast from "../../../provider/Toast/useToast";
import moment from "moment";
import MultiFileBox from "../../../Component/form/multiFileUpload";

const EditGallery = () => {
  const { id } = useParams();
  const toast = useToast();
  const fileRef = useRef(null);
  const navigate = useNavigate();
  const [fileError, setFileError] = useState(false);

  const validationSchema = yup.object().shape({
    name: yup.string().required("Name is a required"),
    date: yup.string().required("Date is a required"),
  });

  const { handleSubmit, handleChange, setFieldValue, values, errors, touched, resetForm } =
    useFormik({
      initialValues: {
        name: "",
        files: [],
        date: "",
      },
      validationSchema,
      onSubmit: async () => {
        if (values?.files?.length > 0) {
          await apiAdminConfig.put(`admin/gallery_update/${id}`, values).then((response) => {
            if (response?.data.status) {
              navigate('/gallery')
              toast({
                message: response?.data?.message,
                bg: 'success'
              });
            } else {
              toast({
                message: response?.data?.message,
                bg: 'danger'
              });
            }
          }).catch((error) => {
            console.log("eventError", error)
            const { response } = error
            toast({
              message: response?.data?.message,
              bg: "danger",
            });
          })
        } else {
          setFileError(true)
        }
      },
    });

  const bindData = async (id) => {
    await apiAdminConfig.get(`admin/gallery/${id}`).then((response) => {
      if (response?.data?.status === true) {
        const { data } = response?.data;
        console.log("datadata", data)
        for (const [key] of Object.entries(values)) {
          if (key === "date") {
            setFieldValue("date", moment(data.date).format('YYYY-MM-DD'));
          } else {
            setFieldValue([key], data[key])
          }
        }
      }
    }).catch((error) => {
      console.log('EventError', error)
    })
  }
  React.useEffect(() => {
    if (id) {
      bindData(id);
    }
  }, [id]);

  return (
    <main id="gallery">
      <Container className="admin_padding">
        <div className="admin_add_form">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              margin: "14px 0",
              alignItems: "center",
            }}
            className="table-hader-container"
          >
            <div>
              <h3 className="table-hader-name">Edit Gallery</h3>
            </div>
            <Link to="/gallery" className="page_add_btn">
              Back
            </Link>
          </div>
          <Row>
            <Col>
              <Form noValidate onSubmit={handleSubmit}>
                <Row className="mb-3">
                  <Col>
                    <Form.Group controlId="validationFormik01">
                      <MultiFileBox
                        accept="image/*"
                        name="files"
                        label="ADD IMAGE"
                        onChange={(e) => {
                          let filesData = values?.files ?? []
                          setFieldValue("files", [...filesData, ...e])
                        }}
                        error={!!errors.files &&
                          touched.files && errors.files}
                        value={values?.files}
                        url="imageUpload/GALLERY"
                        fileError={fileError}
                        isEdit={true}
                        setFileError={setFileError}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Col>
                      <div style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '10px'
                      }}>
                        {values?.files?.length > 0 ? values?.files?.map(list => (
                          <PreviewImage file={list?.url} isDelete={true} id={list?._id ?? ''} setFieldValue={setFieldValue} values={values} />
                        )) : null}
                      </div>
                    </Col>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Form.Group controlId="validationFormik01">
                    <Form.Label>
                      Category Name<span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      value={values.name}
                      onChange={handleChange}
                      isInvalid={!!errors.name && touched.name}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.name}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>

                <Row className="mb-3">
                  <Form.Group controlId="validationFormik01">
                    <Form.Label>
                      Date<span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="date"
                      // min={new Date().toISOString().split('T')[0]}
                      name="date"
                      value={values.date}
                      onChange={handleChange}
                      isInvalid={!!errors.date && touched.date}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.date}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                  className="footer-btns"
                >
                  <Button type="submit" className="input_file_button">
                    Publish
                  </Button>
                  <Link to="/gallery/create">
                    <Button onClick={() => resetForm()} className="input_file_button">Add More</Button>
                  </Link>
                </div>
              </Form>
            </Col>
          </Row>
        </div>
      </Container>
    </main>
  );
};

export default EditGallery;
